import { ComponentProps, FunctionComponent } from "react";
import TubeGreenCap from "./assets/tube-green-cap.svg?react";
import TubePurpleCap from "./assets/tube-purple-cap.svg?react";
import styles from "./styles.module.sass";

// Keyed off the rendered colour word, so this knows nothing about sample types
// or markets. A new cap colour needs its tube added here and tubeCapColour()
// taught to return the word. Artwork is APIBackend's BloodWork/TubeVisual.razor,
// so the lab sees the same tube at accessioning.
const TUBE_ART: Record<
  string,
  FunctionComponent<ComponentProps<"svg">> | undefined
> = {
  green: TubeGreenCap,
  purple: TubePurpleCap,
};

type TubeCapProps = {
  /** The cap colour word, e.g. "green". Not a colour value. */
  capColour: string;
};

/**
 * Drawn beside the colour word, never instead of it: the word stays the
 * carrier, so nothing is lost to colour blindness or to a badly lit room.
 */
export function TubeCap({ capColour }: TubeCapProps) {
  const Tube = TUBE_ART[capColour];
  // No artwork, no tube: a tube in the wrong colour is worse than none, and
  // the sentence reads correctly without one.
  if (Tube == null) {
    return null;
  }

  // Decorative: the visible sentence names the colour and the checkbox's own
  // aria-label repeats it. The assets carry a role and label for standalone
  // use, so both are overridden here.
  return (
    <Tube
      className={styles.tube}
      data-cap-colour={capColour}
      role="presentation"
      aria-label={undefined}
      aria-hidden="true"
      focusable="false"
    />
  );
}
